import TextField, { TextFieldProps } from '@mui/material/TextField';

import { styled } from '@mui/material';

/** Basic MUI text field but with our specific styling */
export const Component = styled(TextField)<TextFieldProps>(({ theme }) => ({
    '& .MuiInput-root': {
        fontSize: '0.875rem',
        fontWeight: 400,
        height: '100%',
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '100px',
        borderWidth: '1px',
    },
    '& .MuiInput-underline': {
        '.MuiInputBase-input': {
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
}));
